var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 79,
    rx: 7.5,
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.157 52.8182V63H52.5163L47.7187 56.0646H47.6342V63H45.7898V52.8182H47.4403L52.233 59.7585H52.3224V52.8182H54.157ZM56.0267 63V52.8182H59.9244C60.6602 52.8182 61.2718 52.9342 61.759 53.1662C62.2495 53.3949 62.6157 53.7081 62.8577 54.1058C63.103 54.5036 63.2256 54.9543 63.2256 55.4581C63.2256 55.8724 63.146 56.227 62.9869 56.522C62.8279 56.8137 62.6141 57.0507 62.3456 57.233C62.0771 57.4152 61.7772 57.5462 61.4458 57.6257V57.7251C61.807 57.745 62.1534 57.8561 62.4848 58.0582C62.8196 58.2571 63.093 58.5388 63.3051 58.9034C63.5173 59.268 63.6233 59.7088 63.6233 60.2259C63.6233 60.7528 63.4957 61.2268 63.2405 61.6477C62.9853 62.0653 62.6008 62.3951 62.0871 62.6371C61.5734 62.879 60.9271 63 60.1482 63H56.0267ZM57.8712 61.4588H59.8548C60.5244 61.4588 61.0066 61.3312 61.3016 61.076C61.5999 60.8175 61.749 60.486 61.749 60.0817C61.749 59.7801 61.6744 59.5083 61.5253 59.2663C61.3762 59.0211 61.164 58.8288 60.8889 58.6896C60.6138 58.5471 60.2857 58.4759 59.9046 58.4759H57.8712V61.4588ZM57.8712 57.1484H59.6958C60.0139 57.1484 60.3006 57.0904 60.5558 56.9744C60.8111 56.8551 61.0116 56.6877 61.1574 56.4723C61.3066 56.2536 61.3811 55.995 61.3811 55.6967C61.3811 55.3023 61.2419 54.9775 60.9635 54.7223C60.6884 54.4671 60.2791 54.3395 59.7355 54.3395H57.8712V57.1484ZM66.3954 63H64.4267L68.0112 52.8182H70.2882L73.8777 63H71.9089L69.1895 54.9062H69.1099L66.3954 63ZM66.4601 59.0078H71.8294V60.4893H66.4601V59.0078Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28C72 34.6274 66.6274 40 60 40M72 28C72 21.3726 66.6274 16 60 16M72 28C68.8174 28 65.7652 26.7357 63.5147 24.4853C61.2643 22.2348 60 19.1826 60 16M60 40C53.3726 40 48 34.6274 48 28M60 40C60 36.8174 58.7357 33.7652 56.4853 31.5147C54.2348 29.2643 51.1826 28 48 28M48 28C48 21.3726 53.3726 16 60 16M51.5334 19.5334L68.4667 36.4667M51.5334 36.4667L68.4667 19.5334",
    stroke: "#1BC4CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/Frame 3.ba2eab154abc25791a044bf00d0e5dcb.svg";
export { ForwardRef as ReactComponent };